import Cookies from 'universal-cookie';
import { jwtDecode } from 'jwt-decode';

import Session from '../Session';

const cookies = new Cookies();

export const SAVE_SESSION = 'SAVE_SESSION';
export const SESSION_LOGOUT = 'SESSION_LOGOUT';

const saveSession = (session) => ({ type: SAVE_SESSION, session });
const sessionLogout = () => ({ type: SESSION_LOGOUT });

const getSessionCookie = () => {
  if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_DEV_SESSION_COOKIE) {
    return process.env.REACT_APP_DEV_SESSION_COOKIE;
  }

  return cookies.get('jwt.payload');
};

const decodeJwtSession = (sessionCookie) => {
  let jwtPayload;

  try {
    jwtPayload = jwtDecode(sessionCookie);
  } catch (e) {
    console.log(e);
  }

  return new Session(jwtPayload);
};

export const updateSession = (navigate) => (dispatch, getState) => {
  const { session: { session: previousSessionState, session: { isAdmin: wasAdmin = false } } } = getState();
  const session = decodeJwtSession(getSessionCookie());

  const loggedOut = (!session.isAuthenticated && previousSessionState.isAuthenticated);

  dispatch(saveSession(session));

  if (loggedOut) {
    dispatch(sessionLogout());

    const loginRedirect = wasAdmin ? '/admin' : '/login';

    if (navigate) {
      navigate(loginRedirect);
    }
  }
};
